import { createFileRoute } from '@tanstack/react-router';
import { AccountProfile } from '@uturn/portal/modules/account/pages/profile';

export const Route = createFileRoute('/_protected/account/')({
	component: AccountProfile,
});
